import script from "./StatsMileShareBehaviorQuery.vue?vue&type=script&lang=js"
export * from "./StatsMileShareBehaviorQuery.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__